import { Injectable } from "@angular/core";

@Injectable()
export class Store {
    q1 = "Wurden Ihre Erwartungen hinsichtlich der Qualität unserer Produkte (Pläne, Berichte, Gutachten, etc.) erfüllt?";
    q2 = "Wie beurteilen Sie die Gesamtleistung unserer Projektleitung?";
    q3 = "Falls es in diesem Projekt wesentliche Probleme mit Qualität und/oder Terminen gab, wurden diese Probleme Ihrer Ansicht nach zufriedenstellend behandelt und gelöst?";
    q4 = "Können Sie uns Vorfälle beschreiben, die Ihnen besonders positiv oder negativ in Erinnerung geblieben sind?";
    doneHeader = "Geschafft!";
    doneMessage = "Vielen Dank, dass Sie teilgenommen haben. Klicken Sie nun auf Absenden um die Umfrage abzuschließen.";
  
    q1En = "Were your expectations regarding quality of our products (drawings, reports, expert opinions, etc.) satisfied?";
    q2En = "How do you assess the overall performance of our project management?";
    q3En = "In case there were problems with quality and/or delivery time: were these problems solved in a satisfactory manner?";
    q4En = "Would you describe incidents, which you experienced in a particularly positive or negative way?";
    doneHeaderEn = "Done!";
    doneMessageEn = "Thank you for participating. Please click on Send to finish the survey.";
    
    q1Answers = [{ value: 1, text: "Ja" }, { value: 2, text: "Teilweise" }, { value: 3, text: "Nein" }];
    q2Answers = [{ value: 1, text: "sehr zufriedenstellend" }, { value: 2, text: "zufriedenstellend" }, { value: 3, text: "wenig zufriedenstellend" }];
    q3Answers = [{ value: 1, text: "Es gab keine wesentlichen Probleme" }, { value: 2, text: "Probleme wurden zufriedenstellend behandelt" }, { value: 3, text: "Probleme wurden nicht zufriedenstellend behandelt" }];

    q1AnswersEn = [{ value: 1, text: "yes" }, { value: 2, text: "partly" }, { value: 3, text: "no" }];
    q2AnswersEn = [{ value: 1, text: "fully satisfied" }, { value: 2, text: "satisfied" }, { value: 3, text: "not satisfied" }];
    q3AnswersEn = [{ value: 1, text: "there were no essential problems" }, { value: 2, text: "problems were well treated and resolved" }, { value: 3, text: "problems were badly treated" }];

    getAnswerAsText(question: string, value: number):string {
        let answerAsText = "";
        if(value != null){
            switch(question){
                case "q1": answerAsText = this.q1Answers.find(a => a.value == value).text; break;
                case "q2": answerAsText = this.q2Answers.find(a => a.value == value).text; break;
                case "q3": answerAsText = this.q3Answers.find(a => a.value == value).text; break;
            }
        }
        return answerAsText;
    }
}